import React from "react";
import logo from "../assets/rutter.svg";

export type LayoutProps = {
  error?: string;
  children?: React.ReactNode;
};

export const Layout = ({ children, error }: LayoutProps) => {
  return (
    <main className="fixed inset-0 z-50 flex flex-col justify-center items-center p-14 box-border">
      <section className="w-full max-w-lg">
        {children}

        {error && (
          <p
            className="mt-1 font-thin text-red-500 text-center mb-[24px]"
            aria-errormessage={error}
          >
            {error}
          </p>
        )}

        <footer className="flex justify-center items-center text-[#697386] gap-4 text-xs sm:text-sm mb-[24px] mt-[16px]">
          <div className="flex gap-1.5 items-center font-semibold">
            <span>Powered by</span>
            <a
              href="https://www.rutter.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={logo} alt="Rutter logo" className="w-14 sm:w-16" />
            </a>
          </div>
          <div className="w-[1.5px] h-4 bg-[#697386]" />
          <div className="flex gap-2 font-semibold">
            <a
              href="https://drive.google.com/file/d/1J77WNI4JS_WjFiXn9NgQVBy_N_unqpCn/view"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms
            </a>
            <a
              href="https://rutterdocs.s3.us-east-2.amazonaws.com/End-user+Privacy+Policy.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy
            </a>
          </div>
        </footer>
      </section>
    </main>
  );
};
